import { FormField } from './FormField';

type Props = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  errors?: string[];
  type?: 'text' | 'number' | 'color' | 'datetime-local' | 'date';
  multiline?: boolean;
  rows?: number;
  placeholder?: string;
  readOnly?: boolean;
  maxLength?: number;
  maxWidth?: number;
};

const DEFAULT_MAX_WIDTH = 500;

/** `FormField` + text-like input (or textarea). */
export const TextField = ({
  label,
  value,
  onChange,
  errors,
  type = 'text',
  multiline,
  rows = 4,
  placeholder,
  readOnly,
  maxLength,
  maxWidth = DEFAULT_MAX_WIDTH,
}: Props) => (
  <FormField label={label} errors={errors}>
    {multiline ? (
      <textarea
        className="form-control"
        style={{ maxWidth }}
        rows={rows}
        value={value}
        placeholder={placeholder}
        readOnly={readOnly}
        maxLength={maxLength}
        onChange={(e) => onChange(e.target.value)}
      />
    ) : (
      <input
        type={type}
        className="form-control input-sm"
        style={{ maxWidth }}
        value={value}
        placeholder={placeholder}
        readOnly={readOnly}
        maxLength={maxLength}
        onChange={(e) => onChange(e.target.value)}
      />
    )}
  </FormField>
);
